<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营管理</el-breadcrumb-item>
      <el-breadcrumb-item>筹建管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">筹建管理</span>
      </div>

      <!-- 搜索条 -->
      <div>
        <el-form :model="queryInfo" :inline="true" size="normal">
          <el-form-item label="关键词：">
            <el-input clearable v-model="queryInfo.query" placeholder="项目名称/客户名称" @clear="getList"></el-input>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="queryInfo.status" placeholder="全部状态" @change="getList" clearable>
              <el-option label="全部" value="all"></el-option>
              <el-option label="筹建中" value="building"></el-option>
              <el-option label="已完成" value="finished"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="接收时间：">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="handleDateChange"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
            <el-button @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格区域 -->
      <el-table :data="list" style="margin-top: 0px" border>
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="任务ID" prop="_id" width="220" show-overflow-tooltip></el-table-column>
        <el-table-column label="项目名称" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.projectInfo ? scope.row.projectInfo.projectName : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="客户名称" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.projectInfo ? scope.row.projectInfo.customerName : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="督导名称" prop="supervisorName" width="100"></el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.finished === 1 ? 'success' : 'warning'">
              {{ scope.row.finished === 1 ? '已完成' : '筹建中' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="接收时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.supervisorOn | date }}
          </template>
        </el-table-column>
        <el-table-column label="完成时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.finishedDate | date }}
          </template>
        </el-table-column>
        <el-table-column label="数据采集状态" width="110">
          <template slot-scope="scope">
            <el-tag size="small" :type="getDataCollectStatusType(scope.row.dataCollectStatus)">
              {{ getDataCollectStatusText(scope.row.dataCollectStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="培训状态" width="100">
          <template slot-scope="scope">
            <el-tag size="small" :type="getTrainingStatusType(scope.row.trainingStatus)">
              {{ getTrainingStatusText(scope.row.trainingStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="账号状态" width="100">
          <template slot-scope="scope">
            <el-tag size="small" :type="getAccountStatusType(scope.row.accountCreateStatus)">
              {{ getAccountStatusText(scope.row.accountCreateStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" plain size="small" @click="deleteClickHandler(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      queryInfo: {
        query: '',
        status: 'all',
        startDate: '',
        endDate: '',
        pagenum: 1,
        pagesize: 20
      },
      dateRange: [],
      total: 0
    }
  },
  created () {
    this.getList()
  },
  methods: {
    // 获取列表
    async getList () {
      const { data: res } = await this.$http.get('choujianManage/list', { params: this.queryInfo })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.list = res.data.list
      this.total = res.data.total
    },

    // 重置查询条件
    resetQuery () {
      this.queryInfo = {
        query: '',
        status: 'all',
        startDate: '',
        endDate: '',
        pagenum: 1,
        pagesize: 20
      }
      this.dateRange = []
      this.getList()
    },

    // 处理日期变化
    handleDateChange (value) {
      if (value) {
        this.queryInfo.startDate = value[0]
        this.queryInfo.endDate = value[1]
      } else {
        this.queryInfo.startDate = ''
        this.queryInfo.endDate = ''
      }
    },

    // 监听pagesize改变的事件
    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getList()
    },

    // 监听页码改变
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getList()
    },

    // 点击删除按钮
    async deleteClickHandler (row) {
      const confirmResult = await this.$confirm(
        '此操作将永久删除该筹建任务，是否继续？',
        '警告',
        {
          confirmButtonText: '确定删除',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)

      if (confirmResult === 'cancel') {
        return this.$message.info('已取消删除')
      }

      const { data: res } = await this.$http.delete(`choujianManage/remove/${row._id}`)
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success('删除成功')
      this.getList()
    },

    // 获取数据采集状态文本
    getDataCollectStatusText (status) {
      const statusMap = {
        0: '未开始',
        1: '待完成',
        2: '已完成'
      }
      return statusMap[status] || '未知'
    },

    // 获取数据采集状态类型
    getDataCollectStatusType (status) {
      const typeMap = {
        0: 'info',
        1: 'warning',
        2: 'success'
      }
      return typeMap[status] || 'info'
    },

    // 获取培训状态文本
    getTrainingStatusText (status) {
      const statusMap = {
        0: '未开始',
        1: '待预约',
        2: '已预约',
        3: '已完成'
      }
      return statusMap[status] || '未知'
    },

    // 获取培训状态类型
    getTrainingStatusType (status) {
      const typeMap = {
        0: 'info',
        1: 'warning',
        2: 'primary',
        3: 'success'
      }
      return typeMap[status] || 'info'
    },

    // 获取账号状态文本
    getAccountStatusText (status) {
      const statusMap = {
        0: '未开始',
        1: '待创建',
        2: '已通知',
        3: '已完成'
      }
      return statusMap[status] || '未知'
    },

    // 获取账号状态类型
    getAccountStatusType (status) {
      const typeMap = {
        0: 'info',
        1: 'warning',
        2: 'primary',
        3: 'success'
      }
      return typeMap[status] || 'info'
    }
  }
}
</script>

<style lang="less" scoped>
.flexContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cardHeader {
  font-size: 18px;
  font-weight: bold;
}

.el-pagination {
  margin-top: 15px;
}
</style>
